import React from "react";

export const Font = ({ title }) => {
  return <h1 className="text-[#55A7FF] text-3xl md:text-[40px] ">{title}</h1>;
};
export const FontGrey = ({ title }) => {
  return (
    <span className="text-[#939090] mt-3 text-xm md:text-lg font-workSans">
      {title}
    </span>
  );
};

// export default Font;
